<template>
  <div class="empty-img">
    <img
      src="https://cdn.moguocdn.com/cdn/static/images/empty.png"
      :style="{ width: imgWidth }"
      alt=""
    />
    <span class="">暂无数据</span>
  </div>
</template>

<script>
export default {
  props: {
    imgWidth: {
      type: String,
      default: "200px",
    },
  },
};
</script>

<style lang="scss" scoped>
.empty-img {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  height: 300px;

  img {
    width: 200px;
  }

  span {
    color: var(--el-text-color-placeholder);
    margin-top: 10px;
    font-size: 14px;
  }
}
</style>
